import React from 'react';
import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react';
import 'react-datepicker/dist/react-datepicker.css';

const PageToolbar = ({
    title,
    subtitle,
    actions,
    dateNavigation,
    children,
    right
}) => (
    <div className="border-b bg-white px-6 py-4">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
            {/* Sol taraf - Başlık ve alt başlık */}
            <div className="flex flex-col gap-1">
                {title && <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>}
                {subtitle && <p className="text-sm text-gray-600">{subtitle}</p>}
            </div>

            {/* Orta/Alt taraf - Actions ve Date Navigation */}
            <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:gap-4">
                {/* Actions */}
                {actions && actions.length > 0 && (
                    <div className="flex flex-wrap items-center gap-2">
                        {actions.map((action, index) => (
                            <button
                                key={index}
                                onClick={action.onClick}
                                className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${action.active
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                    }`}
                            >
                                {action.label}
                            </button>
                        ))}
                    </div>
                )}

                {/* Date Navigation */}
                {dateNavigation && (
                    <div className="flex items-center gap-2">
                        <button
                            onClick={dateNavigation.onPrevious}
                            disabled={!dateNavigation.canNavigate}
                            className="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                            title="Önceki dönem"
                        >
                            <ChevronLeft className="w-4 h-4" />
                        </button>

                        <div className="flex items-center gap-1 px-2 py-1 bg-gray-50 rounded-md">
                            <Calendar className="w-4 h-4 text-gray-500" />
                            <span className="text-sm font-medium text-gray-700">Tarih</span>
                        </div>

                        <button
                            onClick={dateNavigation.onNext}
                            disabled={!dateNavigation.canNavigate}
                            className="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                            title="Sonraki dönem"
                        >
                            <ChevronRight className="w-4 h-4" />
                        </button>
                    </div>
                )}
            </div>

            {/* Sağ taraf */}
            {right && (
                <div className="flex flex-wrap items-center justify-end gap-3">
                    {right}
                </div>
            )}

            {/* Eski children desteği */}
            {children && (
                <div className="flex flex-wrap items-center gap-3">
                    {children}
                </div>
            )}
        </div>
    </div>
);

export default PageToolbar;
